<template>
  <div class="container-fluid mt-5">
    <div>
      <card
        class="no-border-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <template slot="header">
          <div class="row">
            <div class="col-6">
              <h3 class="mb-0">
                {{ $t("SERVICECENTERS.SERVICECENTERS_LIST") }}
              </h3>
            </div>
            <div class="col-6 text-right">
              <base-button
                type="primary"
                icon
                size="sm"
                @click="addServiceCenter()"
                v-if="$currentUserCan($permissions.PERM_CREATE_SERVICECENTERS)"
              >
                <span class="btn-inner--icon">
                  <i class="fas fa-plus"></i>
                </span>
                <span class="btn-inner--text">{{
                  $t("SERVICECENTERS.ADD_SERVICECENTER")
                }}</span>
              </base-button>
            </div>
          </div>
        </template>

        <service-center-list-table />
      </card>
    </div>
  </div>
</template>
<script>
import { Button } from "element-ui";
import ServiceCenterListTable from "./partials/ServiceCenterListTable.vue";

export default {
  layout: "DashboardLayout",

  components: {
    ServiceCenterListTable,
    [Button.name]: Button,
  },

  mixins: [],

  computed: {},

  watch: {},

  methods: {
    addServiceCenter() {
      this.$router.push({ name: "Add ServiceCenter" });
    },
  },
};
</script>
